import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Clipboard } from 'react-native';
import Entypo from '@expo/vector-icons/Entypo';

import Feather from '@expo/vector-icons/Feather';

import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import { LineSaperator } from '../../../../components/calendarList/CalendarList.style';
import AntDesign from '@expo/vector-icons/AntDesign';
import { useDispatch, useSelector } from 'react-redux';
import { tenantActions } from '../../redux/tenant.actions';
import AffPopups from './modals/affPopups';
import moment from 'moment';
import { Button } from '../atoms/button';
import { showErrorToast, showSuccesToast } from '../helpers';
import GuarantorForm from './modals/gurantorPopu';
import ReferencePopUp from './modals/refrecPopup';
import IDVerificationModal from './modals/idverificationModal';
import teanantDetails from './teanantDetails';
import ReferenceComponent from './modals/ReferenceComponent';
import getPlatformType from '../../../../helpers/helpers';


const IdBox = ({ props }) => {


    const renderAff = (FccRentAffordibilityChecks) => {
        let tenantAffordibility1 = null
        if (FccRentAffordibilityChecks) {
            if (FccRentAffordibilityChecks && FccRentAffordibilityChecks?.length > 0) {
                tenantAffordibility1 = FccRentAffordibilityChecks.find((fccRentAffordibilityCheck) => fccRentAffordibilityCheck?.guarantor == false)
            }
        }
        return (
            <View style={[styles.section, { marginRight: layoutType == "web" ? 20 : 0 }]}>
                <View style={styles.sectionHeader}>
                    <Text style={styles.sectionTitle}>Tenant Affordability</Text>
                    <View style={styles.buttonGroup}>
                        {tenantAffordibility1 ? <Text style={styles.green}>Completed</Text> : <Text style={styles.notStarted}>Not Started</Text>}
                    </View>
                </View>
                <View style={styles.documentBox}>
                    <Text style={styles.sectionTitle2}>Tenant Affordability</Text>
                    {tenantAffordibility1 ? <TouchableOpacity
                        style={styles.outlineBtn}
                        onPress={() => {
                            setShowModalAff({ show: true, data: tenantAffordibility1 })
                        }}
                    >
                        <Text style={styles.outlineBtnText}>VIEW</Text>
                    </TouchableOpacity> : null}
                </View>

            </View>
        )
    }
    const renderGAff = (FccRentAffordibilityChecks) => {
        let tenantAffordibility1 = null
        if (FccRentAffordibilityChecks) {
            if (FccRentAffordibilityChecks && FccRentAffordibilityChecks?.length > 0) {
                tenantAffordibility1 = FccRentAffordibilityChecks.find((fccRentAffordibilityCheck) => fccRentAffordibilityCheck?.guarantor == true)
            }
        }
        return (
            <View style={styles.section}>
                <View style={styles.sectionHeader}>
                    <Text style={styles.sectionTitle}>Guarantor Affordability</Text>
                    <View style={styles.buttonGroup}>
                        {tenantAffordibility1 ? <Text style={styles.green}>Completed</Text> : <Text style={styles.notStarted}>Not Started</Text>}
                    </View>
                </View>
                <View style={styles.documentBox}>
                    <Text style={styles.sectionTitle2}>Guarantor Affordability</Text>
                    {tenantAffordibility1 ? <TouchableOpacity
                        style={styles.outlineBtn}
                        onPress={() => {
                            setShowModalAff({ show: true, data: tenantAffordibility1 })
                        }}
                    >
                        <Text style={styles.outlineBtnText}>VIEW</Text>
                    </TouchableOpacity> : null}
                </View>

            </View>
        )
    }
    const renderVerifyByObx = (tenant) => {
        dispatch(tenantActions.verificationByObx({ app_user_id: tenant.app_user_id, flow_id: tenant.openflow_id }, () => {
            fetchFlows()
        }))
    }

    const renderIDVerification = (data) => {
        console.log("renderRtRc", data)
        const { tenant } = data
        return (
            <View style={[styles.section, { marginRight: layoutType == "web" ? 20 : 0 }]}>
                <View style={styles.sectionHeader}>
                    <Text style={styles.sectionTitle}>ID Verification</Text>
                    <View style={styles.buttonGroup}>

                        {
                            tenant?.app_user?.idverification == 2 ?
                                <Text style={styles.green}>Verified</Text> :
                                (tenant?.app_user?.idverification == 3 || tenant?.idverification == 3) ?
                                    <View style={styles.manuallyVerifiedBadge}>
                                        <Feather name="check" size={15} color="#10B981" style={{ marginRight: 4 }} />
                                        <Text style={styles.manuallyVerifiedText}>Manually Verified</Text>
                                    </View> :
                                    tenant?.app_user?.idverification == 9 ?
                                        <Text style={styles.notcompleted}>Failed</Text>
                                        :
                                        tenant?.app_user?.idverification == 1 ?
                                            <Text style={styles.notcompleted}>Pending</Text>
                                            :
                                            tenant?.app_user?.idverification == 5 ?
                                                <Text style={styles.requested}>Requested</Text>
                                                :
                                                <Text style={styles.notStarted}>Not Started</Text>
                        }

                        {tenant?.app_user?.idverification != 2 && tenant?.app_user?.idverification != 3 && tenant?.idverification != 3 ? (
                            <TouchableOpacity
                                style={styles.outlineActionBtn}
                                onPress={() => { renderVerifyByObx(tenant) }}
                            >
                                <Text style={styles.outlineActionBtnText}>Manually Verify</Text>
                            </TouchableOpacity>
                        ) : null
                        }

                        <Button
                            type="Upload"
                            title="UPLOAD"
                            style={styles.purpleUploadBtn}
                            onClick={(IMAGEDATA) => {
                                if (IMAGEDATA && IMAGEDATA?.data?.length) {

                                    if (IMAGEDATA && IMAGEDATA.data.length) {
                                        dispatch(tenantActions.getVerificationReferencing({
                                            document_url: IMAGEDATA?.data[0],
                                            flow_id: flowId,
                                            open_flow_sub_tenant_id: data?.open_flow_sub_tenant_id,
                                            type_of_document: "verification"
                                        }, () => {
                                            fetchFlows()
                                            showSuccesToast('Document uploaded successfully!')
                                        }))
                                    }

                                }
                            }}
                        />

                        {tenant.app_user.idverification == 5 && tenant.app_user.idverification !== 2 ?
                            <TouchableOpacity
                                onPress={() => {
                                    dispatch(tenantActions.rtrReminder({ "app_user_id": data?.app_user_id }, flowId, () => {
                                        showSuccesToast('Id verification reminder sent successfully!')
                                    }, "/openflow/id_verification/reminder?"))
                                }}
                                style={styles.nudgeButton}><Text style={styles.buttonText}>NUDGE</Text></TouchableOpacity>
                            : null}
                    </View>
                </View>
                <View style={styles.documentBox}>
                    <Text style={styles.sectionTitle3}>ID Verification Document</Text>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        {(tenant.app_user.idverification == 0 || tenant.app_user.idverification == 3) ? (
                            <TouchableOpacity
                                style={[styles.outlineBtn, { marginRight: 8 }]}
                                onPress={() => {
                                    const payload = {
                                        flow_id: flowId,
                                        tlife: tenant.app_user.opbrix_id,
                                        ...tenant
                                    }
                                    setShowStartIDVerificationModal({
                                        data: payload,
                                        show: true
                                    })
                                }}
                            >
                                <Text style={styles.outlineBtnText}>REQUEST</Text>
                            </TouchableOpacity>
                        ) : null}

                        <TouchableOpacity
                            disabled={tenant?.app_user?.idverification !== 2}
                            style={[styles.outlineBtn, tenant?.app_user?.idverification !== 2 ? styles.outlineBtnDisabled : null]}
                            onPress={() => {
                                if (tenant?.app_user?.yoti_verification_document) {
                                    window.open(tenant?.app_user?.yoti_verification_document, "_blank")
                                }
                            }}
                        >
                            <Text style={tenant?.app_user?.idverification !== 2 ? styles.outlineBtnTextDisabled : styles.outlineBtnText}>DOWNLOAD</Text>
                        </TouchableOpacity>
                    </View>
                </View>
                {data?.right_to_rent_document && data?.right_to_rent_document?.length ?
                    data.right_to_rent_document.map((item, index) => {
                        return (
                            <View key={item?.document_url || index} style={styles.documentItem}>
                                <Text style={styles.sectionTitle3}>Document {index + 1}</Text>
                                <View style={styles.documentActions}>
                                    <Text style={styles.date}>{formatDate(item.updatedAt)}</Text>
                                    <TouchableOpacity onPress={() => {
                                        if (item?.document_url)
                                            window.open(item.document_url, '_blank');
                                    }}>
                                        <AntDesign name={"eye"} size={22} color="#09b2c2" />

                                    </TouchableOpacity>
                                    <TouchableOpacity
                                        onPress={() => {
                                            dispatch(tenantActions.deleteRtrDoc({
                                                document_url: item?.document_url,
                                                flow_id: flowId,
                                                open_flow_sub_tenant_id: data?.open_flow_sub_tenant_id,
                                                type_of_document: "verification"
                                            }, () => {
                                                fetchFlows()
                                                showSuccesToast('Document deleted successfully!')
                                            }))
                                        }}
                                    >
                                        <MaterialIcons name="delete" size={22} color="#E53E3E" />
                                    </TouchableOpacity>
                                </View>
                            </View>
                        )
                    }) : null
                }
            </View>
        )
    }
    const formatDate = (date) => moment(date).format('DD/MM/YYYY')
    const renderRtRc = (data) => {
        console.log("renderRtRc", data)
        const alreadyRequestedOrCompleted = Boolean(data.right_to_rent_requested || (data.right_to_rent && data.right_to_rent_dob));
        const isCompleted = Boolean(data.right_to_rent && data.right_to_rent_dob);

        return (
            <View style={styles.section}>
                <View style={styles.sectionHeader}>
                    <Text style={styles.sectionTitle}>Right To Rent</Text>
                    <View style={styles.buttonGroup}>

                        {
                            data.right_to_rent_approved ?
                                <Text style={styles.green}>Approved</Text> :
                                data.right_to_rent && data.right_to_rent_dob ?
                                    <Text style={styles.requested}>Submitted By Tenant</Text>
                                    :
                                    data.right_to_rent_requested ?
                                        <Text style={styles.requested}>Requested</Text>
                                        :
                                        <Text style={styles.notStarted}>Not Started</Text>
                        }


                        <Button
                            type="Upload"
                            title="UPLOAD"
                            style={styles.purpleUploadBtn}
                            onClick={(IMAGEDATA) => {
                                if (IMAGEDATA && IMAGEDATA?.data?.length) {

                                    if (IMAGEDATA && IMAGEDATA.data.length) {
                                        dispatch(tenantActions.getVerificationReferencing({
                                            document_url: IMAGEDATA?.data[0],
                                            flow_id: flowId,
                                            open_flow_sub_tenant_id: data?.open_flow_sub_tenant_id,
                                            type_of_document: "right_to_rent"
                                        }, () => {
                                            fetchFlows()
                                            showSuccesToast('Document uploaded successfully!')
                                        }))
                                    }

                                }
                            }}
                        />

                        {data.right_to_rent_approved == false && (!data.right_to_rent && !data.right_to_rent_dob) ?
                            <TouchableOpacity
                                onPress={() => {
                                    dispatch(tenantActions.rtrReminder({ "app_user_id": data.app_user_id }, flowId, () => {
                                        showSuccesToast('Right to rent reminder sent successfully!')
                                    }))
                                }}
                                style={styles.nudgeButton}><Text style={styles.buttonText}>NUDGE</Text></TouchableOpacity>
                            : null}
                    </View>
                </View>
                <View style={styles.documentBox}>
                    <View>
                        <Text style={styles.detailTextLine}><Text style={styles.bold}>Code:</Text> {data?.right_to_rent ? data?.right_to_rent : "N/A"}</Text>
                        <Text style={[styles.detailTextLine, { marginTop: 4 }]}><Text style={styles.bold}>Birth Date:</Text> {data?.right_to_rent_dob ? formatDate(data?.right_to_rent_dob) : "N/A"}</Text>
                    </View>

                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        {!alreadyRequestedOrCompleted ? (
                            <TouchableOpacity
                                style={[styles.outlineBtn, { marginRight: 8 }]}
                                onPress={() => {
                                    dispatch(tenantActions.requestrighttorent({ flow_id: flowId, app_user_id: data.app_user_id }, () => {
                                        fetchFlows();
                                        showSuccesToast('Right to rent requested successfully');
                                    }));
                                }}
                            >
                                <Text style={styles.outlineBtnText}>REQUEST</Text>
                            </TouchableOpacity>
                        ) : null}

                        {isCompleted ? (
                            <TouchableOpacity
                                style={[styles.outlineBtn, { marginRight: 8 }]}
                                onPress={() => {
                                    window.open("https://www.gov.uk/view-right-to-rent", "_blank");
                                }}
                            >
                                <Text style={styles.outlineBtnText}>CHECK</Text>
                            </TouchableOpacity>
                        ) : null}

                        {isCompleted && !data.right_to_rent_approved ? (
                            <TouchableOpacity
                                style={styles.outlineBtnGreen}
                                onPress={() => {
                                    dispatch(tenantActions.postRtrCode({ flow_id: flowId, app_user_id: data.app_user_id }, () => {
                                        fetchFlows();
                                        showSuccesToast('Right to rent approved successfully');
                                    }));
                                }}
                            >
                                <Text style={styles.outlineBtnTextGreen}>APPROVE</Text>
                            </TouchableOpacity>
                        ) : null}
                    </View>
                </View>
                {data?.right_to_rent_document && data?.right_to_rent_document?.length ?
                    data.right_to_rent_document.map((item, index) => {
                        return (
                            <View key={item?.document_url || index} style={styles.documentItem}>
                                <Text style={styles.sectionTitle3}>Document {index + 1}</Text>
                                <View style={styles.documentActions}>
                                    <Text style={styles.date}>{formatDate(item.updatedAt)}</Text>
                                    <TouchableOpacity onPress={() => {
                                        if (item?.document_url)
                                            window.open(item.document_url, '_blank');
                                    }}>
                                        <AntDesign name={"eye"} size={22} color="#09b2c2" />

                                    </TouchableOpacity>
                                    <TouchableOpacity
                                        onPress={() => {
                                            dispatch(tenantActions.deleteRtrDoc({
                                                document_url: item?.document_url,
                                                flow_id: flowId,
                                                open_flow_sub_tenant_id: data?.open_flow_sub_tenant_id,
                                                type_of_document: "right_to_rent"
                                            }, () => {
                                                fetchFlows()
                                                showSuccesToast('Document deleted successfully!')
                                            }))
                                        }}
                                    >
                                        <MaterialIcons name="delete" size={22} color="#E53E3E" />
                                    </TouchableOpacity>
                                </View>
                            </View>
                        )
                    }) : null
                }
            </View>
        )
    }

    const [refModal, setRefModal] = React.useState(null);
    const [grefModal, setGRefModal] = React.useState(null);


    const renderRef = (data) => {
        const { tenant } = data
        console.log("data", data)
        let reference = null
        let latestUpdate = null
        let rentReadyReference = null
        if (tenant && tenant?.app_user?.FccPrequalifications && tenant?.app_user?.FccPrequalifications?.length > 0) {
            rentReadyReference = tenant.app_user.FccPrequalifications[0]
        }
        if (tenant.fccReference) {
            reference = tenant.fccReference
            if (tenant.fccReference.fcc_references_updates && tenant.fccReference.fcc_references_updates.length > 0) {
                const referenceUpdates = tenant.fccReference.fcc_references_updates;
                if (referenceUpdates[0] && Object.keys(referenceUpdates[0]).length > 0) {
                    referenceUpdates.sort((a, b) => new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime());
                    const latestUpdate1 = {
                        ...referenceUpdates[0],
                        handler: JSON.parse(referenceUpdates[0].handler),
                        progress: JSON.parse(referenceUpdates[0].progress),
                        documents: JSON.parse(referenceUpdates[0].documents),
                    };
                    if (latestUpdate1.handler && latestUpdate1.handler.length > 0) {
                        const handler = latestUpdate1.handler[0]
                        latestUpdate1.handlerName = `${handler.title[0]} ${handler.first_name[0]} ${handler.last_name[0]}`
                        latestUpdate1.handlerContactNumber = `${handler.phone_number[0]}`
                    }
                    if (latestUpdate1.progress && latestUpdate1.progress.length > 0) {
                        latestUpdate1.currentEmployment = {
                            comments: latestUpdate1.progress[0].current_employment[0],
                            status: latestUpdate1.progress[0].current_employment_status[0],
                            last_updated: latestUpdate1.progress[0].current_employment_date_last_updated[0],
                        }
                        latestUpdate1.creditSearch = {
                            comments: latestUpdate1.progress[0].search_details[0],
                            status: latestUpdate1.progress[0].search_details_status[0],
                            last_updated: latestUpdate1.progress[0].search_details_date_last_updated[0],
                        }
                        latestUpdate1.currentLiving = {
                            comments: latestUpdate1.progress[0].current_living[0],
                            status: latestUpdate1.progress[0].current_living_status[0],
                            last_updated: latestUpdate1.progress[0].current_living_date_last_updated[0],
                        }
                        latestUpdate1.tenantSearch = {
                            comments: latestUpdate1.progress[0].tenant_database[0],
                            status: latestUpdate1.progress[0].tenant_database_status[0],
                            last_updated: latestUpdate1.progress[0].tenant_database_date_last_updated[0],
                        }
                    }
                    latestUpdate = latestUpdate1;
                } else {
                    latestUpdate = null
                }
            }
        } else {
            reference = null
            latestUpdate = null
        }


        const getTenantFullName = () => {
            return `${tenant?.app_user?.user?.first_name?.toUpperCase()} ${tenant?.app_user?.user?.last_name?.toUpperCase()}`
        }


        return (
            <View style={[styles.section, { marginRight: layoutType == "web" ? 20 : 0 }]}>
                <ReferenceComponent
                    data={{
                        name: getTenantFullName(),
                        latestUpdate: latestUpdate
                    }}
                    showModal={refModal}
                    onclose={() => {
                        setRefModal(false)
                    }}
                />
                <View style={styles.sectionHeader}>
                    <Text style={styles.sectionTitle}>Referencing</Text>
                    <View style={styles.buttonGroup}>
                        {
                            reference?.completed ?
                                <Text style={styles.green}>Completed</Text> :
                                !reference ?
                                    <Text style={styles.notcompleted}>Not Started</Text>
                                    :

                                    <Text style={styles.requested}>Pending</Text>
                        }

                        <Button
                            type="Upload"
                            title="Upload"
                            style={{ width: 70, height: 20 }}
                            onClick={(IMAGEDATA) => {
                                if (IMAGEDATA && IMAGEDATA?.data?.length) {
                                    if (IMAGEDATA && IMAGEDATA.data.length) {
                                        dispatch(tenantActions.getVerificationReferencing({
                                            document_url: IMAGEDATA?.data[0],
                                            flow_id: flowId,
                                            open_flow_sub_tenant_id: data?.open_flow_sub_tenant_id,
                                            type_of_document: "referencing"
                                        }, () => {
                                            fetchFlows()
                                            showSuccesToast('Document uploaded successfully!')
                                        }))
                                    }
                                }
                            }}
                        />
                    </View>
                </View>

                <>
                    <View style={styles.documentBox}>
                        <Text style={styles.sectionTitle2}>Tenant Referencing</Text>
                        {!reference ?

                            <TouchableOpacity onPress={() => {
                                setShowModalRef({
                                    show: true,
                                    data: {
                                        tenants: [tenant],
                                        digital_reference: false,
                                        guarantors: []
                                    }
                                })
                            }}>
                                <Text style={styles.green}>Start Referencing</Text>
                            </TouchableOpacity> : latestUpdate ?
                                <View style={{ flexDirection: "column" }}>

                                    <TouchableOpacity
                                        style={{ marginBottom: 6 }}
                                        onPress={() => {
                                            setRefModal(true)
                                        }}>
                                        <Text style={styles.green}>  View Updates</Text>
                                    </TouchableOpacity>
                                    {latestUpdate?.final_response_pdf ?

                                        <TouchableOpacity onPress={() => {
                                            window.open(latestUpdate?.final_response_pdf, "_blank")
                                        }}>
                                            <Text style={styles.green}>  View Document</Text>
                                        </TouchableOpacity> : null}
                                </View> : <Text style={styles.notcompleted}> Not Completed</Text>
                        }

                    </View>

                    {reference ? <View style={styles.documentBox}>
                        <Text style={styles.sectionTitle3}>Reference Application </Text>
                        {latestUpdate?.application_pdf ?
                            <TouchableOpacity onPress={() => {
                                window.open(latestUpdate?.application_pdf, "_blank")
                            }}>
                                <Text style={styles.green}>Download</Text>
                            </TouchableOpacity>
                            :

                            <Text style={styles.notcompleted}>Not Completed</Text>

                        }
                    </View> : null}
                    {reference?.url ?

                        <View style={styles.documentBox}>
                            <Text style={styles.sectionTitle3}>Application Link </Text>
                            <TouchableOpacity onPress={() => {
                                copyToClipboard(reference?.url)
                            }}>
                                <Text style={styles.green}>Copy Link</Text>
                            </TouchableOpacity>
                        </View> : null}

                    {reference && (
                        <View style={styles.referenceInfo}>
                            <View style={styles.detailRow}>
                                <Text style={styles.bold}>Reference Handler:</Text>
                                <Text style={styles.detailText}>{latestUpdate?.handlerName || 'N/A'}</Text>
                            </View>
                            <View style={styles.detailRow}>
                                <Text style={styles.bold}>Tel:</Text>
                                <Text style={styles.detailText}>{latestUpdate?.handlerContactNumber || 'N/A'}</Text>
                            </View>
                            <View style={styles.detailRow}>
                                <Text style={styles.bold}>Ref:</Text>
                                <Text style={styles.detailText}>{reference?.fcc_reference_id || 'N/A'}</Text>
                            </View>
                        </View>
                    )}
                </>
                {data?.gua_document && data?.gua_document?.length ?
                    data.gua_document.map((item, index) => {
                        return (
                            <View key={data?.document_url} style={styles.documentItem}>
                                <Text style={styles.sectionTitle3}>Document {index + 1}</Text>
                                <View style={styles.documentActions}>
                                    <Text style={styles.date}>{formatDate(item.updatedAt)}</Text>
                                    <TouchableOpacity onPress={() => {
                                        if (item?.document_url)
                                            window.open(item.document_url, '_blank');
                                    }}>
                                        <AntDesign name={"eye"} size={30} color="#09b2c2" />

                                    </TouchableOpacity>
                                    <TouchableOpacity
                                        onPress={() => {
                                            dispatch(tenantActions.deleteRtrDoc({
                                                document_url: item?.document_url,
                                                flow_id: flowId,
                                                open_flow_sub_tenant_id: data?.open_flow_sub_tenant_id,
                                                type_of_document: "referencing"
                                            }, () => {
                                                fetchFlows()
                                                showSuccesToast('Document deleted successfully!')
                                            }))
                                        }}
                                    >
                                        <MaterialIcons name="delete" size={24} color="#E53E3E" />
                                    </TouchableOpacity>
                                </View>
                            </View>
                        )
                    }) : null
                }
            </View>
        )
    }
    const copyToClipboard = async (url) => {
        await Clipboard.setString(url);
        showSuccesToast('Link has been copied to your clipbord')
    };


    const renderGRef = (data) => {
        const { fccReference, tenName } = data
        console.log("renderGRef", data)
        let reference = null
        let latestUpdate = null
        if (fccReference && fccReference.length) {


            const guarantorId = data?.open_flow_guarantor?.open_flow_guarantor_id;

            const tmpReference = fccReference?.find((reference) => {
                return reference.guarantor_id == guarantorId;
            })

            if (tmpReference) {
                reference = tmpReference
                if (tmpReference.fcc_references_updates && tmpReference.fcc_references_updates.length > 0) {
                    const referenceUpdates = tmpReference.fcc_references_updates;
                    if (referenceUpdates[0] && Object.keys(referenceUpdates[0]).length > 0) {
                        referenceUpdates.sort((a, b) => new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime());
                        const latestUpdate1 = {
                            ...referenceUpdates[0],
                            handler: JSON.parse(referenceUpdates[0].handler),
                            progress: JSON.parse(referenceUpdates[0].progress),
                            documents: JSON.parse(referenceUpdates[0].documents),
                        };
                        if (latestUpdate1.handler && latestUpdate1.handler.length > 0) {
                            const handler = latestUpdate1.handler[0]
                            latestUpdate1.handlerName = `${handler.title[0]} ${handler.first_name[0]} ${handler.last_name[0]}`
                            latestUpdate1.handlerContactNumber = `${handler.phone_number[0]}`
                        }
                        if (latestUpdate1.progress && latestUpdate1.progress.length > 0) {
                            latestUpdate1.currentEmployment = {
                                comments: latestUpdate1.progress[0].current_employment[0],
                                status: latestUpdate1.progress[0].current_employment_status[0],
                                last_updated: latestUpdate1.progress[0].current_employment_date_last_updated[0],
                            }
                            latestUpdate1.creditSearch = {
                                comments: latestUpdate1.progress[0].search_details[0],
                                status: latestUpdate1.progress[0].search_details_status[0],
                                last_updated: latestUpdate1.progress[0].search_details_date_last_updated[0],
                            }
                            latestUpdate1.currentLiving = {
                                comments: latestUpdate1.progress[0].current_living[0],
                                status: latestUpdate1.progress[0].current_living_status[0],
                                last_updated: latestUpdate1.progress[0].current_living_date_last_updated[0],
                            }
                            latestUpdate1.tenantSearch = {
                                comments: latestUpdate1.progress[0].tenant_database[0],
                                status: latestUpdate1.progress[0].tenant_database_status[0],
                                last_updated: latestUpdate1.progress[0].tenant_database_date_last_updated[0],
                            }
                        }
                        latestUpdate = latestUpdate1;
                    } else {
                        latestUpdate = null
                    }
                }
            } else {
                reference = null
                latestUpdate = null
            }
        }

        return (
            <View style={styles.section}>
                <ReferenceComponent
                    showModal={grefModal}
                    data={{
                        name: "",
                        latestUpdate: latestUpdate
                    }}
                    onclose={() => {
                        setGRefModal(false)
                    }}
                />
                <View style={styles.sectionHeader}>
                    <Text style={styles.sectionTitle}>Guarantor</Text>
                    <View style={styles.buttonGroup}>
                        {
                            reference?.completed ?
                                <Text style={styles.green}>Completed</Text> :
                                !reference ?
                                    <Text style={styles.notcompleted}>Not Started</Text>
                                    :

                                    <Text style={styles.requested}>Pending</Text>
                        }

                        <Button
                            type="Upload"
                            title="Upload"
                            style={{ width: 70, height: 20 }}
                            onClick={(IMAGEDATA) => {
                                if (IMAGEDATA && IMAGEDATA?.data?.length) {
                                    if (IMAGEDATA && IMAGEDATA.data.length) {
                                        dispatch(tenantActions.getVerificationReferencing({
                                            document_url: IMAGEDATA?.data[0],
                                            flow_id: flowId,
                                            open_flow_sub_tenant_id: data?.open_flow_sub_tenant_id,
                                            type_of_document: "guarantor_docs"
                                        }, () => {
                                            fetchFlows()
                                            showSuccesToast('Document uploaded successfully!')
                                        }))
                                    }
                                }
                            }}
                        />
                    </View>
                </View>
                {data?.open_flow_guarantor?.email ? (
                    <>
                        <View style={styles.sectionContent}>
                            <View style={styles.contentHeader}>
                                <View style={styles.userInfo}>
                                    <View style={styles.avatar}>
                                        <Text style={styles.avatarText}>
                                            {getInitials(data?.open_flow_guarantor?.first_name, data?.open_flow_guarantor?.last_name)}
                                        </Text>
                                    </View>
                                    <Text style={styles.title}>
                                        {data?.open_flow_guarantor?.first_name} {data?.open_flow_guarantor?.last_name}
                                    </Text>
                                </View>
                                <View style={styles.actionButtons}>
                                    <TouchableOpacity
                                        onPress={() => {
                                            setShowModalGua({ show: true, data: { open_flow_sub_tenant_id: data.open_flow_sub_tenant_id, tenName: tenName, ...data, isEdit: true } })
                                        }}
                                        style={styles.iconButton}
                                    >
                                        <Feather name={"edit"} size={24} color="#09b2c2" />
                                    </TouchableOpacity>
                                    <TouchableOpacity
                                        onPress={() => {
                                            dispatch(tenantActions.deleteGau({
                                                flow_id: flowId,
                                                openflow_guarantor_id: data.open_flow_guarantor.open_flow_guarantor_id,
                                                force_remove_from_flow: true,
                                            }, () => {
                                                fetchFlows()
                                                showSuccesToast('Guarantor removed from flow successfully!')
                                            }))
                                        }}
                                        style={styles.iconButton}
                                    >
                                        <MaterialIcons name="delete" size={24} color="#E53E3E" />
                                    </TouchableOpacity>
                                </View>
                            </View>

                            <View style={styles.detailRow}>
                                <Text style={styles.bold}>Email:</Text>
                                <Text style={styles.detailText}>{data?.open_flow_guarantor?.email ? data?.open_flow_guarantor?.email : "N/A"}</Text>
                            </View>

                            <View style={styles.detailRow}>
                                <Text style={styles.bold}>Postcode:</Text>
                                <Text style={styles.detailText}>{data?.open_flow_guarantor?.post_code ? data?.open_flow_guarantor?.post_code : "N/A"}</Text>
                            </View>

                            <View style={styles.detailRow}>
                                <Text style={styles.bold}>Contact Number:</Text>
                                <Text style={styles.detailText}>{data?.open_flow_guarantor?.number ? data?.open_flow_guarantor?.number : "N/A"}</Text>
                            </View>
                        </View>

                        <View style={styles.documentBox}>
                            <Text style={styles.documentTitle}>Guarantor Referencing</Text>
                            {!reference ? (
                                <TouchableOpacity
                                    onPress={() => {
                                        setShowModalRef({
                                            show: true,
                                            data: {
                                                guarantors: [data?.open_flow_guarantor],
                                                digital_reference: false,
                                                tenants: [],
                                                open_flow_sub_tenant_id: data.open_flow_sub_tenant_id
                                            }
                                        })
                                    }}
                                    style={styles.actionButton}
                                >
                                    <Text style={styles.green}>Start Referencing</Text>
                                </TouchableOpacity>
                            ) : latestUpdate ? (
                                <TouchableOpacity
                                    onPress={() => setGRefModal(true)}
                                    style={styles.actionButton}
                                >
                                    <Text style={styles.green}>View Updates</Text>
                                </TouchableOpacity>
                            ) : latestUpdate?.final_response_pdf ? (
                                <TouchableOpacity
                                    onPress={() => window.open(latestUpdate?.final_response_pdf, "_blank")}
                                    style={styles.actionButton}
                                >
                                    <Text style={styles.green}>View Document</Text>
                                </TouchableOpacity>
                            ) : null}
                        </View>

                        {reference && (
                            <View style={styles.documentBox}>
                                <Text style={styles.documentTitle}>Reference Application</Text>
                                {latestUpdate?.application_pdf ? (
                                    <TouchableOpacity
                                        onPress={() => window.open(latestUpdate?.application_pdf, "_blank")}
                                        style={styles.actionButton}
                                    >
                                        <Text style={styles.green}>Download</Text>
                                    </TouchableOpacity>
                                ) : (
                                    <Text style={styles.notcompleted}>Not Completed</Text>
                                )}
                            </View>
                        )}

                        {reference?.url && (
                            <View style={styles.documentBox}>
                                <Text style={styles.documentTitle}>Application Link</Text>
                                <TouchableOpacity
                                    onPress={() => copyToClipboard(reference?.url)}
                                    style={styles.actionButton}
                                >
                                    <Text style={styles.green}>Copy Link</Text>
                                </TouchableOpacity>
                            </View>
                        )}

                        {reference && (
                            <View style={styles.referenceInfo}>
                                <View style={styles.detailRow}>
                                    <Text style={styles.bold}>Reference Handler:</Text>
                                    <Text style={styles.detailText}>{latestUpdate?.handlerName || 'N/A'}</Text>
                                </View>
                                <View style={styles.detailRow}>
                                    <Text style={styles.bold}>Tel:</Text>
                                    <Text style={styles.detailText}>{latestUpdate?.handlerContactNumber || 'N/A'}</Text>
                                </View>
                                <View style={styles.detailRow}>
                                    <Text style={styles.bold}>Ref:</Text>
                                    <Text style={styles.detailText}>{reference?.fcc_reference_id || 'N/A'}</Text>
                                </View>
                            </View>
                        )}
                    </>
                ) : (
                    <View style={styles.documentBox}>
                        <Text style={styles.documentTitle}>Guarantor Information</Text>
                        <TouchableOpacity
                            onPress={() => {
                                setShowModalGua({ show: true, data: { open_flow_sub_tenant_id: data.open_flow_sub_tenant_id, tenName: tenName } })
                            }}
                            style={styles.actionButton}
                        >
                            <Text style={styles.requested}>Add</Text>
                        </TouchableOpacity>
                    </View>
                )}

                {data?.gua_document && data?.gua_document?.length > 0 && (
                    data.gua_document.map((item, index) => (
                        <View key={item?.document_url} style={styles.documentItem}>
                            <Text style={styles.documentTitle}>Document {index + 1}</Text>
                            <View style={styles.documentActions}>
                                <Text style={styles.date}>{formatDate(item.updatedAt)}</Text>
                                <TouchableOpacity
                                    onPress={() => {
                                        if (item?.document_url) window.open(item.document_url, '_blank');
                                    }}
                                    style={styles.iconButton}
                                >
                                    <AntDesign name={"eye"} size={24} color="#09b2c2" />
                                </TouchableOpacity>
                                <TouchableOpacity
                                    onPress={() => {
                                        dispatch(tenantActions.deleteRtrDoc({
                                            document_url: item?.document_url,
                                            flow_id: flowId,
                                            open_flow_sub_tenant_id: data?.open_flow_sub_tenant_id,
                                            type_of_document: "guarantor_docs"
                                        }, () => {
                                            fetchFlows()
                                            showSuccesToast('Document deleted successfully!')
                                        }))
                                    }}
                                    style={styles.iconButton}
                                >
                                    <MaterialIcons name="delete" size={24} color="#E53E3E" />
                                </TouchableOpacity>
                            </View>
                        </View>
                    ))
                )}
            </View>
        )
    }
    const [flowId, setFlowId] = React.useState(null);
    const [checkedValue, setCheckedValue] = useState("");
    const [flow, setFlow] = React.useState({});
    const [addedUsers, setAddedUsers] = React.useState([]);
    const [showModalAff, setShowModalAff] = React.useState({
        show: false,
        data: null
    });
    const [showModalGua, setShowModalGua] = React.useState({
        show: false,
        data: null
    });
    const [showModalRef, setShowModalRef] = React.useState({
        show: false,
        data: null
    });
    const [showStartIDVerificationModal, setShowStartIDVerificationModal] = React.useState({
        show: false,
        data: null
    });


    const dispatch = useDispatch()
    const globalState = useSelector((state) => state?.tenant.flowIdInfo);
    const tenantsArry = useSelector((state) => state?.tenant?.flowIdInfo?.tenants);
    const [allReferences, setAllReferences] = useState([]);

    useEffect(() => {
        console.log("proooooo", props)
        if (props?.route?.params?.id) {
            setFlowId(props?.route?.params?.id);
            fetchFlows()
        }
    }, [props?.route?.params?.id]);
    const fetchFlows = () => {
        dispatch(tenantActions.getFlowInfo(props?.route?.params?.id));
    }
    useEffect(() => {
        if (tenantsArry && tenantsArry?.length) {
            setAddedUsers(tenantsArry);
            setFlow(globalState);
            if (!checkedValue && tenantsArry[0]?.app_user_id) {
                setCheckedValue(tenantsArry[0]?.app_user_id);
            }
        } else {
            setAddedUsers([]);
        }
        if (globalState.fccReferences && globalState.fccReferences.length) {
            setAllReferences(globalState.fccReferences)
        }
    }, [tenantsArry]);

    function getInitials(firstName, lastName) {
        if (firstName && lastName) {
            return `${firstName[0]}${lastName[0]}`.toUpperCase();
        } else if (lastName) {
            return lastName.slice(0, 2).toUpperCase();
        }
        return ''; // Fallback for no names provided
    }
    const getRightToRentDocuments = (open_flow_verifications) => {
        const documentType = 'right_to_rent';
        if (open_flow_verifications && open_flow_verifications.length) {
            const rightToRentDocuments = open_flow_verifications.filter((document) => {
                return document?.type_of_document == documentType
            });

            return rightToRentDocuments
        } else {
            return []
        }
    }
    const getIdDoc = (open_flow_verifications) => {
        const documentType = 'verification';
        if (open_flow_verifications && open_flow_verifications.length) {
            const rightToRentDocuments = open_flow_verifications.filter((document) => {
                return document?.type_of_document == documentType
            });

            return rightToRentDocuments
        } else {
            return []
        }
    }
    const getGuaToRentDocuments = (open_flow_verifications) => {
        const documentType = 'guarantor_docs';
        if (open_flow_verifications && open_flow_verifications.length) {
            const rightToRentDocuments = open_flow_verifications.filter((document) => {
                return document?.type_of_document == documentType
            });

            return rightToRentDocuments
        } else {
            return []
        }
    }
    const getRefDocuments = (open_flow_verifications) => {
        const documentType = 'referencing';
        if (open_flow_verifications && open_flow_verifications.length) {
            const rightToRentDocuments = open_flow_verifications.filter((document) => {
                return document?.type_of_document == documentType
            });

            return rightToRentDocuments
        } else {
            return []
        }
    }

    return (
        <>
            {tenantsArry && tenantsArry.length ?
                tenantsArry.map((item, index) => {
                    console.log("itemitem", item)
                    return (

                        <View key={index} style={styles.container}>

                            <View style={styles.header}>
                                <View style={styles.avatarContainer}>
                                    <View style={styles.avatar}>
                                        <Text style={styles.avatarText}>
                                            {getInitials(item?.app_user?.user?.first_name, item?.app_user?.user?.last_name)}
                                        </Text>
                                    </View>
                                    <View style={styles.titleContainer}>
                                        <Text style={styles.title}>
                                            {item?.app_user?.user?.first_name} {item?.app_user?.user?.last_name}{" "}
                                            <Text style={styles.email}>
                                                ({item?.app_user?.user?.email})
                                            </Text>
                                        </Text>
                                    </View>
                                </View>

                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                    <TouchableOpacity
                                        style={{ marginLeft: 16 }}
                                        onPress={() => {
                                            if (checkedValue === item?.app_user_id)
                                                setCheckedValue("")
                                            else
                                                setCheckedValue(item?.app_user_id)
                                        }}>
                                        <AntDesign
                                            name={checkedValue === item?.app_user_id ? "minus" : "plus"}
                                            size={20}
                                            color="#A0AEC0"
                                        />
                                    </TouchableOpacity>
                                </View>
                            </View>


                            {checkedValue == item?.app_user_id ?
                                <>
                                    <View style={{ height: 1, backgroundColor: '#EDF2F7', marginVertical: 16 }} />
                                    <View style={styles.sectionContainer}>
                                        {/* ID Verification Section */}
                                        {renderIDVerification({
                                            tenant: item,
                                            app_user_id: item?.app_user_id,
                                            open_flow_sub_tenant_id: item?.open_flow_sub_tenant_id,
                                            right_to_rent_document: getIdDoc(item?.open_flow_verifications),

                                        }
                                        )}

                                        {/* Right To Rent Section */}
                                        {renderRtRc({
                                            right_to_rent: item?.app_user?.right_to_rent,
                                            right_to_rent_approved: item?.app_user?.right_to_rent_approved,
                                            right_to_rent_dob: item?.app_user?.right_to_rent_dob,
                                            right_to_rent_document: getRightToRentDocuments(item?.open_flow_verifications),
                                            right_to_rent_expiry: item?.app_user?.right_to_rent_expiry,
                                            right_to_rent_requested: item?.app_user?.right_to_rent_requested,
                                            open_flow_sub_tenant_id: item?.open_flow_sub_tenant_id,
                                            app_user_id: item?.app_user_id
                                        })}
                                    </View>
                                    {/* Affordability Section */}
                                    <View style={styles.sectionContainer}>
                                        {renderAff(item?.app_user?.FccRentAffordibilityChecks)}
                                        {/* Guarantor Affordability Section */}
                                        {renderGAff(item?.app_user?.FccRentAffordibilityChecks)}
                                    </View>
                                    <View style={styles.sectionContainer}>
                                        {/* Referencing Section */}

                                        {renderRef({
                                            tenant: item,
                                            open_flow_sub_tenant_id: item?.open_flow_sub_tenant_id,
                                            app_user_id: item?.app_user_id,
                                            gua_document: getRefDocuments(item?.open_flow_verifications),
                                            fccReference: item.fccReference,
                                        })}
                                        {renderGRef({
                                            open_flow_guarantor: item?.open_flow_guarantor,
                                            open_flow_sub_tenant_id: item?.open_flow_sub_tenant_id,
                                            app_user_id: item?.app_user_id,
                                            gua_document: getGuaToRentDocuments(item?.open_flow_verifications),
                                            fccReference: allReferences,
                                            tenName: item?.app_user?.user?.first_name + " " + item?.app_user?.user?.last_name
                                        })}
                                    </View>
                                </> : null}
                        </View>
                    )
                }) : null
            }
            <AffPopups
                showModal={showModalAff.show}
                onClose={() => { setShowModalAff({ show: false, data: null }) }}
                data={showModalAff.data}
            />

            <GuarantorForm
                showModal={showModalGua.show}
                onClose={() => { setShowModalGua({ show: false, data: null }) }}
                data={showModalGua.data}
                onSave={(DATA) => {
                    let payload =
                    {
                        "email": DATA.email,
                        "title": DATA.title,
                        "number": DATA.contactNumber,
                        "last_name": DATA.lastName,
                        "post_code": DATA.postcode,
                        "first_name": DATA.firstName,
                        "correspondece_address": DATA.address,
                        "flow_id": flowId,
                        "open_flow_sub_tenant_id": showModalGua?.data?.open_flow_sub_tenant_id
                    }
                    dispatch(tenantActions.saveGurantorInfo(payload, () => {
                        fetchFlows()
                        showSuccesToast('Guarantor added successfully!');
                        setShowModalGua({ show: false, data: null })

                    }))
                }}


            />
            {showStartIDVerificationModal.show ?
                <IDVerificationModal
                    visible={showStartIDVerificationModal?.show}
                    data={showStartIDVerificationModal?.data}
                    onClose={() => setShowStartIDVerificationModal(false)}
                    onStart={() => {
                        const payload = {
                            flow_id: flowId,
                            tlife: showStartIDVerificationModal?.data?.tlife,
                        }
                        dispatch(tenantActions.requestdigital(payload, flowId, () => {
                            fetchFlows()
                            showSuccesToast('Id Verifiation started successfully!');
                            setShowStartIDVerificationModal({ show: false, data: null })
                        }))
                    }}

                /> : null}
            <ReferencePopUp
                showModal={showModalRef.show}
                onClose={() => { setShowModalRef({ show: false, data: null }) }}
                data={showModalRef.data}
                onSave={(DATA) => {
                    console.log("showModalRef", showModalRef)
                    let payload =
                    {
                        ...showModalRef.data,
                        "flow_id": flowId,
                        "open_flow_sub_tenant_id": showModalGua?.data?.open_flow_sub_tenant_id,
                        "price": DATA.cost,
                        digital_reference: false,
                    }
                    dispatch(tenantActions.fullReferencing(payload, (data) => {
                        if (data.status) {
                            fetchFlows()
                            setShowModalRef({ show: false, data: null })
                        } else {
                            showErrorToast(data?.message ? data.message : 'Please try again!');
                            setShowModalRef({ show: false, data: null })
                        }
                    }))
                }}


            />

        </>
    );

};
const layoutType = getPlatformType();
const styles = StyleSheet.create({
    container: {
        padding: 20,
        backgroundColor: '#fff',
        borderRadius: 12,
        borderWidth: 1,
        borderColor: '#EDF2F7',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.04,
        shadowRadius: 6,
        elevation: 2,
        marginBottom: 24,
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        paddingVertical: 4,
    },
    avatarContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        flexShrink: 1,
        flexGrow: 1,
    },
    avatar: {
        width: 36,
        height: 36,
        borderRadius: 18,
        backgroundColor: '#F3E8FF',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 12,
    },
    avatarText: {
        color: '#8A63D2',
        fontWeight: '700',
        fontSize: 13,
        fontFamily: 'lato',
    },
    titleContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        flexShrink: 1,
    },
    title: {
        fontSize: 15,
        fontWeight: '700',
        color: '#2e4374',
        fontFamily: 'lato',
    },
    email: {
        color: '#718096',
        fontSize: 14,
        fontWeight: '400',
        fontFamily: 'lato',
    },
    sectionContainer: {
        flexDirection: layoutType !== "web" ? "column" : 'row',
        marginBottom: layoutType !== "web" ? 0 : 16,
        justifyContent: 'space-between',
    },
    section: {
        flex: 1,
        padding: 18,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: '#EDF2F7',
        marginTop: 16,
        backgroundColor: '#fff',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.03,
        shadowRadius: 4,
        elevation: 1,
    },
    sectionHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 8,
        flexWrap: 'wrap',
        gap: 8,
    },
    sectionTitle: {
        color: '#2e4374',
        fontWeight: '600',
        fontSize: 16,
        fontFamily: 'lato',
    },
    sectionTitle2: {
        fontWeight: '500',
        fontSize: 14,
        color: '#4A5568',
        fontFamily: 'lato',
    },
    sectionTitle3: {
        fontWeight: '500',
        fontSize: 14,
        color: '#4A5568',
        fontFamily: 'lato',
    },
    buttonGroup: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
    },
    requested: {
        borderWidth: 1,
        borderColor: '#D8B4FE',
        color: '#8B5CF6',
        borderRadius: 16,
        paddingHorizontal: 12,
        paddingVertical: 3,
        fontSize: 12,
        fontWeight: '500',
        fontFamily: 'lato',
        justifyContent: 'center',
        alignItems: 'center',
    },
    notcompleted: {
        borderWidth: 1,
        borderColor: '#FED7D7',
        color: '#E53E3E',
        borderRadius: 16,
        paddingHorizontal: 12,
        paddingVertical: 3,
        fontSize: 12,
        fontWeight: '500',
        fontFamily: 'lato',
        justifyContent: 'center',
        alignItems: 'center',
    },
    green: {
        borderWidth: 1,
        borderColor: '#A7F3D0',
        color: '#10B981',
        borderRadius: 16,
        paddingHorizontal: 12,
        paddingVertical: 3,
        fontSize: 12,
        fontWeight: '500',
        fontFamily: 'lato',
        justifyContent: 'center',
        alignItems: 'center',
    },
    notStarted: {
        borderWidth: 1,
        borderColor: '#D8B4FE',
        color: '#8B5CF6',
        borderRadius: 16,
        paddingHorizontal: 12,
        paddingVertical: 3,
        fontSize: 12,
        fontWeight: '500',
        fontFamily: 'lato',
        justifyContent: 'center',
        alignItems: 'center',
    },
    manuallyVerifiedBadge: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: 1.5,
        borderColor: '#10B981',
        borderRadius: 20,
        paddingHorizontal: 12,
        paddingVertical: 3,
        backgroundColor: '#FFFFFF',
    },
    manuallyVerifiedText: {
        color: '#10B981',
        fontSize: 12,
        fontWeight: '600',
        fontFamily: 'lato',
    },
    outlineActionBtn: {
        borderWidth: 1,
        borderColor: '#10B981',
        borderRadius: 16,
        paddingHorizontal: 10,
        paddingVertical: 3,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'transparent',
    },
    outlineActionBtnText: {
        color: '#10B981',
        fontSize: 12,
        fontWeight: '600',
        fontFamily: 'lato',
    },
    purpleUploadBtn: {
        width: 72,
        height: 26,
        backgroundColor: '#8a63d2',
        borderRadius: 6,
        border: 'none',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 11,
        fontWeight: '700',
        letterSpacing: 0.5,
        cursor: 'pointer',
        fontFamily: 'lato',
    },
    nudgeButton: {
        backgroundColor: '#8a63d2',
        borderRadius: 6,
        paddingHorizontal: 12,
        height: 26,
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttonText: {
        color: '#fff',
        fontSize: 11,
        fontWeight: '700',
        fontFamily: 'lato',
        letterSpacing: 0.5,
    },
    documentBox: {
        padding: 14,
        borderWidth: 1,
        borderColor: '#EDF2F7',
        borderRadius: 8,
        marginTop: 16,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
    },
    documentTitle: {
        fontWeight: '500',
        fontSize: 14,
        color: '#4A5568',
        fontFamily: 'lato',
    },
    detailTextLine: {
        fontSize: 14,
        color: '#4A5568',
        fontFamily: 'lato',
    },
    bold: {
        fontWeight: '700',
        color: '#2D3748',
        fontFamily: 'lato',
    },
    outlineBtn: {
        borderWidth: 1,
        borderColor: '#365FF2',
        borderRadius: 4,
        paddingHorizontal: 12,
        height: 28,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'transparent',
    },
    outlineBtnText: {
        color: '#365FF2',
        fontSize: 12,
        fontWeight: '600',
        letterSpacing: 0.5,
        fontFamily: 'lato',
    },
    outlineBtnDisabled: {
        borderColor: '#E2E8F0',
    },
    outlineBtnTextDisabled: {
        color: '#CBD5E1',
        fontSize: 12,
        fontWeight: '600',
        letterSpacing: 0.5,
        fontFamily: 'lato',
    },
    outlineBtnGreen: {
        borderWidth: 1,
        borderColor: '#10B981',
        borderRadius: 4,
        paddingHorizontal: 12,
        height: 28,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'transparent',
    },
    outlineBtnTextGreen: {
        color: '#10B981',
        fontSize: 12,
        fontWeight: '600',
        letterSpacing: 0.5,
        fontFamily: 'lato',
    },
    documentItem: {
        padding: 12,
        borderWidth: 1,
        borderColor: '#EDF2F7',
        borderRadius: 8,
        marginTop: 12,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
    },
    documentActions: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    date: {
        color: '#718096',
        fontSize: 13,
        fontFamily: 'lato',
        marginRight: 6,
    },
    sectionContent: {
        padding: 14,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#EDF2F7',
        marginTop: 12,
        backgroundColor: '#FFFFFF',
    },
    contentHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 12,
        flexWrap: 'wrap',
    },
    userInfo: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
        flexWrap: 'wrap',
    },
    actionButtons: {
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: 8,
    },
    iconButton: {
        padding: 4,
        marginLeft: 8,
    },
    detailRow: {
        flexDirection: 'row',
        marginBottom: 6,
        flexWrap: 'wrap',
    },
    detailText: {
        marginLeft: 4,
        flex: 1,
        fontSize: 14,
        color: '#4A5568',
        fontFamily: 'lato',
    },
    referenceInfo: {
        marginTop: 12,
        padding: 12,
        borderWidth: 1,
        borderColor: '#EDF2F7',
        borderRadius: 8,
        backgroundColor: '#FFFFFF',
    },
    actionButton: {
        paddingHorizontal: 8,
    },
});

export default IdBox;
